import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import CalculatorContext from "../../Context/CalculatorContext";

import { STEPS_PAGINATION } from "../../Constants/RouteConstants";

function StepsHeadline({ children }) {
  const { currentStepIndex } = useContext(CalculatorContext);

  const navigate = useNavigate();

  return (
    <div className="frame frame-indent-8 frame-space-before-small frame-space-after-extra-small">
      <div className="frame-inner">
        <div className="row">
          {currentStepIndex === 0 ? (
            <div className="col-md-1" />
          ) : (
            <div className="col-md-1">
              <div className="form-wizard-nav justify-content-right">
                <ul className="pagination">
                  <li className="page-item page-item-prev page-item-prev-mobile">
                    <a
                      className="page-link prev"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();

                        navigate(STEPS_PAGINATION[currentStepIndex - 1]);
                      }}
                      aria-label="Go to previous step"
                    >
                      <i className="icon-line-arrow-left" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}
          <div className="col">
            <header className="frame-header frame-header-h3 frame-header-space-small">
              {children}
            </header>
          </div>
          <div className="col-lg-1" />
        </div>
      </div>
    </div>
  );
}

StepsHeadline.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StepsHeadline;
